import React, { FocusEvent } from "react";
import { Row, Col } from "react-bootstrap";
import { ActionHandlerFunction, AdminUser, Sort } from "@preveil-api";
import { DriveUIActionTypes, getSelectedState, SORT_DIRECTION } from "src/common";
import { Checkbox, EmptyView, Icon, Loading } from "src/components";
import { UsersListRow } from "..";
import _ from "lodash";

type AllProps = {
  is_loading: boolean;
  users_list: AdminUser[];
  selected: string[];
  sort: Sort<keyof AdminUser>;
  handleAction: ActionHandlerFunction;
};

function UsersListViewComponent(props: AllProps) {
  const { is_loading, selected, users_list, sort, handleAction } = props;

  // Descriptions: Shareable react fragment - for each field - returns the header with sort icon
  function headerWithSortIcon(name: string, field: string) {
    const length = users_list.length;
    return (
      <>
        {name}
        {!!sort && sort.field === field && length > 0 && (
          <Icon className={`${sort.direction === SORT_DIRECTION.descending ? "ficon-arrow-down" : "ficon-arrow-up"} small-icon ps-1`} />
        )}
      </>
    );
  }

  // Description: Render the rows of Admin Users view
  function RenderList(_list: AdminUser[]) {
    return (
      <div className="list-body">
        {_.map(_list, (_user: AdminUser, i: number) => {
          return (
            <UsersListRow
              key={`item_${i}`}
              user={_user}
              handleAction={handleAction}
              selected={selected.includes(_user.user_id)}
            />
          );
        })}
      </div>
    );
  }

  // Description: Handles Sorting
  function handleSort(field: string) {
    handleAction({ actionType: DriveUIActionTypes.SetSort, params: field });
  }

  return (
    <div className={`admin-list-view admin-users ${is_loading ? " isloading" : ""}`}>
      {!!users_list && users_list.length > 0 && (
        <Row className="header-row">
          <Col md="1">
            <Checkbox
              className="sr-only"
              onChange={(e: FocusEvent<HTMLInputElement>) => {
                handleAction({
                  actionType: DriveUIActionTypes.Select,
                  params: { selected: e.target.checked },
                });
              }}
              value="all"
              label="Select All"
              selected={getSelectedState(selected, users_list.length)}
            />
          </Col>
          <Col md="3" className="col" onClick={() => handleSort("display_name")}>{headerWithSortIcon("Name", "display_name")}</Col>
          <Col md="2" onClick={() => handleSort("user_id")}>{headerWithSortIcon("Email", "user_id")}</Col>
          <Col md="2" onClick={() => handleSort("department")}>{headerWithSortIcon("Department", "department")}</Col>
          <Col onClick={() => handleSort("role")}>{headerWithSortIcon("Role", "role")}</Col>
          <Col md="3" onClick={() => handleSort("recovery_group")}>{headerWithSortIcon("Recovery Group", "recovery_group")}</Col>
          <Col md="1">Due</Col>
        </Row>
      )}
      {!!users_list && users_list.length > 0 ? (
        RenderList(users_list)
      ) : !is_loading ? <EmptyView message="No matches found!" className="mt-5" /> : null}

      {is_loading && <Loading />}
    </div>
  );
}

export default React.memo(UsersListViewComponent);
